import { FunctionComponent } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useAppState } from "@/context/AppState";
import { useParams } from "@/hooks/queryParams";
import { getAccessToken } from "@/utils/auth";

// A higher order component that ensures the user is authenticated
// using the tourToken before displaying the child component.
export default function RequireAuthentication(
  WrappedComponent: FunctionComponent<{ accessToken: string }>
) {
  return function RequireAuthenticationComponent(props: object) {
    const [{ config, accessTokens }, _setAppState] = useAppState();
    const groupId = config?.groupId;
    const accessToken = getAccessToken({ accessTokens, groupId });
    const location = useLocation();
    const history = useHistory();
    const { tourToken } = useParams();

    if (!accessToken && tourToken) {
      history.push({
        pathname: `/tour/${tourToken}/sms-verification-consent`,
        search: `?redirect=${location.pathname}`,
      });
    }

    return <WrappedComponent {...props} accessToken={accessToken as string} />;
  };
}
